<ng-container *transloco="let t; read: 'partials.conference'">
  <ng-container *ngIf="ac?.virtual === true && ac?.conference_url">
    <div class="dashboard-block">
      <label for="date">{{ t('online_conference') }}</label>
      <button pButton type="button" class="p-button-sm p-mt-1 p-mb-2" (click)="openConference()" icon="pi pi-video" [label]="t('open_conference')"></button>
      <!-- <span class="mod-info"><i class="pi pi-video p-mr-2"></i><a (click)="openConference()">{{ t('open_conference') }}</a></span> -->
      <span class="mod-info" *ngIf="auth.isModerator() && ac.conference_info"><i class="pi pi-info-circle p-mr-2"></i>{{ ac.conference_info }}</span>
    </div>
  </ng-container>
</ng-container>
